import type { IrReport } from './types';
import { G1_IR_REPORTS } from './g1';
import { G2_IR_REPORTS } from './g2';
import { G3_IR_REPORTS } from './g3';
import { G4_IR_REPORTS } from './g4';
import { applyReportOverride, irOverride } from '../reportContent';

export type { IrReport, IrSection, IrBlock, Tone } from './types';

const ALL: IrReport[] = [...G1_IR_REPORTS, ...G2_IR_REPORTS, ...G3_IR_REPORTS, ...G4_IR_REPORTS];

export const IR_REPORTS_BY_KEY: Record<string, IrReport> = ALL.reduce(
  (acc, r) => { acc[r.key] = r; return acc; },
  {} as Record<string, IrReport>,
);

// The seven readiness stages in order (index 0 = R1). Used by the PDF's journey stepper.
export const IR_STAGES: { rCode: string; stage: string }[] = [
  { rCode: 'R1', stage: 'Critical Risk' },
  { rCode: 'R2', stage: 'Very High Risk' },
  { rCode: 'R3', stage: 'High Risk' },
  { rCode: 'R4', stage: 'Medium Risk' },
  { rCode: 'R5', stage: 'Semi-Ready' },
  { rCode: 'R6', stage: 'Investor-Ready' },
  { rCode: 'R7', stage: 'Exceptional' },
];

// IR-Score → readiness band R1..R7. Mirrors the IRScore page's mapToR() and the
// capital-readiness scoreToRCode(): R1 ≤33, R2 ≤41, R3 ≤48, R4 ≤56, R5 ≤65, R6 ≤74, else R7.
export function scoreToRCode(score: number): string {
  if (score <= 33) return 'R1';
  if (score <= 41) return 'R2';
  if (score <= 48) return 'R3';
  if (score <= 56) return 'R4';
  if (score <= 65) return 'R5';
  if (score <= 74) return 'R6';
  return 'R7';
}

// Resolve the report for a goal group (G1–G4) and IR score. Falls back to G1.
export function getIrReport(group: string | undefined | null, score: number): IrReport | undefined {
  const g = group === 'G1' || group === 'G2' || group === 'G3' || group === 'G4' ? group : 'G1';
  const r = IR_REPORTS_BY_KEY[`${g}${scoreToRCode(score)}`];
  return r ? applyReportOverride(r, irOverride(r.key)) : r;
}
